var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChoose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "613.5px",
    height: "397.309px",
    viewBox: "0 0 613.5 397.309",
    enableBackground: "new 0 0 613.5 397.309",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 613.929,
    height: 397.309
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#F05054",
    d: "M613.929,124.144V8.344c-1.813-0.316-24.531-3.861-47.262,12.488 c-23.696,17.043-59.24,14.179-99.862,7.305s-60.933-6.005-79.551,0c-18.618,6.004-50.129,27.069-111.334,26.635 c-54.192-0.385-66.3-24.155-114.383-9c-34.115,10.752-63.212,16-92.309,5c-18.354-6.939-46.155-13-68.728-5L0,123.827 c0.311,0.027,0.62-0.005,0.929-0.023v268.935c20.357,1.847,55.209,3.392,92.433-2.188c58.31-8.742,139.943-1.082,170.688,3.425 c7.989,1.171,19.006,2.405,32.376,3.333h88.546c21.7-1.442,44.925-4.048,68.848-8.333c61.236-10.968,128.132-5.897,159.681-2.379 v-262.56C613.645,124.069,613.781,124.117,613.929,124.144"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#E54141",
    d: "M612.429,8.133V0.161c0,0-28-1.939-41,7.645 c-24.412,17.996-55,22.569-104,18.002s-51.304-9-103,9s-88,16.45-125,6.761c-37-9.688-58-11.193-89,0.636 c-31,11.828-68,15.054-88-0.396s-62-10-62-10v21l0.026,0.017L0.5,45.771c22.573-8,50.374-1.938,68.728,5 c29.097,11,58.195,5.753,92.309-5c48.083-15.154,60.191,8.615,114.383,9c61.205,0.436,92.716-20.63,111.334-26.635 c18.618-6.004,38.929-6.873,79.551,0c40.622,6.874,76.166,9.739,99.862-7.304C586.704,6.421,606.721,7.466,612.429,8.133"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/choose.6e0155fc11ad33aa2226e94ac67fd45d.svg";
export { ForwardRef as ReactComponent };